import { useContext } from "react";
import AuthContext from "../../store/AuthContext";
import ProfileContactFrame, {
  IPersonCard,
} from "../../components/Layout/Frames/ProfileContactFrame";
import FirmFrame, { IFirmCard } from "../../components/Layout/Frames/FirmFrame";
import Groups from "../../components/Atomos/Icons/ViewMode/Groups";

import RedAndWhiteCard from "./Cards/RedAndWhiteCard";
import Tune from "../../components/Atomos/Icons/Tune";
import User from "../../components/Atomos/Icons/User";
import Lock from "../../components/Atomos/Icons/Lock";
import Referrals from "../../components/Atomos/Icons/Referrals";
import CalendarMonth from "../../components/Atomos/Icons/CalendarMonth";

const MainBox = ({
  personCard,
  firmData,
}: {
  personCard: IPersonCard;
  firmData: IFirmCard;
}) => {
  console.log(firmData);
  const { loggedPerson } = useContext(AuthContext);
  const baseMenuItems = [
    { name: "My WSG Inbox", icon: <Referrals />, to: "/wsg_mailbox.asp" },
    {
      name: "Edit My Profile",
      icon: <User />,
      to: `/profile/attorney/${loggedPerson?.name}-${loggedPerson?.lastName}/${loggedPerson?.legacyId ?? loggedPerson?.generatedId}`,
    },
    { name: "Preferences", icon: <Tune />, to: "/my-preferences" },
    { name: "My Network", icon: <Groups />, to: "/preferred_contacts.asp" },
    { name: "Settings", icon: <Lock />, to: "/settings" },
  ];

  const menuItems = loggedPerson?.firmAdminAccess
    ? [
        { name: "Dashboard", icon: <CalendarMonth />, to: "/dashboard.asp" },
        ...baseMenuItems,
      ]
    : baseMenuItems;

  return (
    <div className="flex flex-col md:flex-row bg-white w-full p-4 lg:p-10 rounded-t-lg gap-10 md:gap-4 lg:gap-10">
      <div className="flex flex-col gap-10 flex-1 max-w-[22rem] ">
        <ProfileContactFrame
          id={loggedPerson?.id ?? ""}
          name={personCard?.name}
          lastName={personCard?.lastName}
          title={personCard?.title}
          listTitle={personCard?.listTitle}
          city={personCard?.city}
          country={personCard?.country}
          socialNetworks={personCard?.socialNetworks}
          photo={personCard?.photo ?? ""}
          _ts={personCard?._ts}
        />
        <FirmFrame
          id={firmData?.id}
          legacyId={firmData?.legacyId ?? ""}
          logo={firmData?.logo}
          name={firmData?.name ?? ""}
          mainOffice={firmData?.mainOffice ?? ""}
          linkedinUrl={firmData?.linkedinUrl}
          xUrl={firmData?.xUrl}
          facebookUrl={firmData?.facebookUrl}
          instagramUrl={firmData?.instagramUrl}
          youtubeUrl={firmData?.youtubeUrl}
          hasMoreOffices={firmData?.hasMoreOffices}
        />
      </div>

      <div className="w-px bg-primary-light mx-4 hidden md:block" />

      <div className="flex flex-1">
        <div className="flex flex-col flex-1 w-full">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 w-full h-full">
            {menuItems.map((item) => (
              <RedAndWhiteCard
                key={item.to}
                icon={item.icon}
                name={item.name}
                to={item.to}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBox;
